// Author lidongxu
// Date 2023-08-17 16:39:13

class EmDictData {
constructor({
        id = null,
        dictType = '',
        dictValue = '',
        dictLabel = '',
        status = '',
        isDefault = '',
        remark = ''}
= {}) {
    this.id = id;
    this.dictType = dictType;
    this.dictValue = dictValue;
    this.dictLabel = dictLabel;
    this.status = status;
    this.isDefault = isDefault;
    this.remark = remark;
}
}

function newEntity() {
return new EmDictData();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.admin.emDictData.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'dictType',
        label: 'label.em.admin.emDictData.grid.dictType',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'dictValue',
        label: 'label.em.admin.emDictData.grid.dictValue',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'dictLabel',
        label: 'label.em.admin.emDictData.grid.dictLabel',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'status',
        label: 'label.em.admin.emDictData.grid.status',
        sortable: true,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
        ,options: [
                { value: '0', text: '启用' },
                            { value: '1', text: '停用' }
            ]
        }
        },
        {
        key: 'isDefault',
        label: 'label.em.admin.emDictData.grid.isDefault',
        sortable: true,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
        ,options: [
                { value: 'Y', text: '是' },
                            { value: 'N', text: '否' }
            ]
        }
        },
        {
        key: 'remark',
        label: 'label.em.admin.emDictData.grid.remark',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    dictTypeFilter : '',
    dictValueFilter : '',
    dictLabelFilter : '',
    statusFilter : '',
    isDefaultFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'dictTypeFilter',
        label: 'label.em.admin.emDictData.filter.dictType',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'dictValueFilter',
        label: 'label.em.admin.emDictData.filter.dictValue',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'dictLabelFilter',
        label: 'label.em.admin.emDictData.filter.dictLabel',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'statusFilter',
        label: 'label.em.admin.emDictData.filter.status',
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
         ,options: [
                { value: '0', text: '启用' },
                { value: '1', text: '停用' }
            ]
        }
        },
        {
        key: 'isDefaultFilter',
        label: 'label.em.admin.emDictData.filter.isDefault',
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
         ,options: [
                { value: 'Y', text: '是' },
                { value: 'N', text: '否' }
            ]
        }
        }
];


    const entityFormConfigs = [
        {
        key: 'dictValue',
        label: 'label.em.admin.emDictData.entity.dictValue',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'dictLabel',
        label: 'label.em.admin.emDictData.entity.dictLabel',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'status',
        label: 'label.em.admin.emDictData.entity.status',
        sortable: true,
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
        ,options: [
                { value: '0', text: '启用' },
                { value: '1', text: '停用' }
            ]
        }
        },
        {
        key: 'isDefault',
        label: 'label.em.admin.emDictData.entity.isDefault',
        sortable: true,
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
        ,options: [
                { value: 'Y', text: '是' },
                { value: 'N', text: '否' }
            ]
        }
        },
        {
        key: 'remark',
        label: 'label.em.admin.emDictData.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        }
]

export {EmDictData, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
